import { z } from 'zod';
import { BILL_TYPES, BILL_BILLING_STATUSES } from '../types/jobBill';

// --- Job Bill ---

export const createJobBillSchema = z.object({
  jobId: z.string().uuid(),
  billType: z.enum(BILL_TYPES),
});

export const updateJobBillSchema = z.object({
  billingStatus: z.enum(BILL_BILLING_STATUSES).optional(),
});

// --- Versioning ---

export const createBillVersionSchema = z.object({
  name: z.string().min(1),
});

// --- Inferred Types ---

export type CreateJobBillInput = z.infer<typeof createJobBillSchema>;
